document.addEventListener("DOMContentLoaded", () => {
  const buttons = document.querySelectorAll(".wa-button");

  if (buttons) {
    buttons.forEach((button) => {
      button.addEventListener("click", () => {
        const eventName = button.dataset.event;
        try {
          gtag("event", `book_${eventName}`, {
            event_category: "Booking",
            event_label: `Clicked from ${window.pageTitle}`,
            value: 1,
          });
        } catch (e) {}
      });
    });
  }
});
